<template>
  <v-btn
    block
    :loading="signingOut"
    variant="outlined"
    @click="authSignOut()"
  >
    Log out
  </v-btn>
</template>

<script setup lang="ts">
const { signOut } = useAuth();
const signingOut = ref(false);

const authSignOut = () => {
  signingOut.value = true;
  return signOut();
};
</script>
